import { useEffect } from "react";
import businessConfig from "../config/businessConfig";

export function useSEO(overrides) {
  var seo = Object.assign({}, businessConfig.seo, overrides);

  useEffect(function() {
    document.title = seo.title;

    function setMeta(name, content, isProperty) {
      var attr = isProperty ? "property" : "name";
      var el = document.querySelector("meta[" + attr + "='" + name + "']");
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    }

    setMeta("description",         seo.description,  false);
    setMeta("keywords",            seo.keywords,     false);
    setMeta("author",              seo.author,       false);
    setMeta("theme-color",         seo.themeColor,   false);
    setMeta("og:title",            seo.title,        true);
    setMeta("og:description",      seo.description,  true);
    setMeta("og:url",              seo.url,          true);
    setMeta("og:type",             "website",        true);
    setMeta("twitter:card",        "summary",        false);
    setMeta("twitter:title",       seo.title,        false);
    setMeta("twitter:description", seo.description,  false);

  }, [seo.title, seo.description, seo.keywords, seo.author, seo.themeColor, seo.url]);
}